"use strict";
const signalRServices_1 = require("../../common/src/signalR/signalRServices");
const plc_1 = require("./plc");
exports.PLC_HUBSERVICEPROVIDER_ENTRY = { provide: signalRServices_1.IHUBSERVICE_TOKEN, useClass: plc_1.InaxPlcService, multi: true };
